import { combineReducers } from 'redux';
import { useDispatch } from 'react-redux';
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import themeReducer from '../reducers/theme';
import alocacaoReducer from '../../../app/modules/alocacao/reducers/alocacao.reducer';
import autenticacaoReducer from '../../../app/modules/autenticacao/reducers/autenticacao.reducer';

const reducers = combineReducers({
  theme: themeReducer,
  alocacao: alocacaoReducer,
  autenticacao: autenticacaoReducer,
});

const persistConfig = {
  key: 'sisiec',
  storage: storage,
  blacklist: ['alocacao'],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export { store, persistor };
